import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

Vue.use(Router)

const viewRouters = [
	// view页面的模板
	{
		path: '/view-template',
		name: 'viewTemplate',
		meta: {
			title: 'view模板'
		},
		component: () => import('../views/view-template/index')
	},
	{
		path: '/',
		name: 'login',
		meta: {
			title: '登录页',
			landscape: false
		},
		component: () => import('../views/login/index')
	},
	{
		path: '/pollutionRose',
		name: 'pollutionRose',
		meta: {
			title: '污染玫瑰',
			landscape: true // 横屏显示
		},
		component: () => import('../views/pollution-rose')
	},
	// 日历
	{
		path: '/calendar',
		name: 'calendar',
		meta: {
			title: '空气日历',
			landscape: false
		},
		component: () => import('../views/calendar')
	},
	{
		path: '/download',
		name: 'download',
		meta: {
			title: '下载页'
		},
		component: () => import('../views/download')
	}
]

const demoRouters = [
	// demo页面的模板
	{
		path: '/demo-template',
		name: 'demoTemplate',
		meta: {
			title: 'demo模板'
		},
		component: () => import('../demos/demo-template/index')
	},
	{
		path: '/slot',
		name: 'slot',
		meta: {
			title: '插槽-slot'
		},
		component: () => import('../demos/slot/slot')
	},
	{
		path: '/vuejswar',
		name: 'vuejswar',
		meta: {
			title: 'vue.js实战'
			// keepAlive: true,
		},
		component: () => import('../demos/vuejswar/vuejswar')
	},
	{
		path: '/shoppingCart',
		name: 'shoppingCart',
		meta: {
			title: 'vue.js实战-购物车'
		},
		component: () => import('../demos/vuejswar/shoppingCart')
	},
	{
		path: '/pdf',
		name: 'pdf',
		meta: {
			title: 'pdf预览'
		},
		component: () => import('../demos/pdf/pdf')
	},
	{
		path: '/drag',
		name: 'drag',
		meta: {
			title: 'drag拖拽'
			// keepAlive: false,
		},
		component: () => import('../demos/drag/drag')
	},
	{
		path: '/weather',
		name: 'weather',
		meta: {
			title: '天气预报'
		},
		component: () => import('../demos/weather/weather')
	},
	{
		path: '/callCamera',
		name: 'callCamera',
		meta: {
			title: '调用摄像头',
			landscape: false
		},
		component: () => import('../demos/callCamera/callCamera')
	},
	{
		path: '/cordova',
		name: 'cordova',
		meta: {
			title: 'cordova能力'
		},
		component: () => import('../demos/cordova/cordova')
	},
	{
		path: '/clickaway',
		name: 'clickaway',
		meta: {
			title: '插件vue-clickaway2'
		},
		component: () => import('../demos/clickaway/index')
	}
]

const routes = viewRouters.concat(demoRouters)

const router = new Router({
	routes
})

router.beforeEach(async (to, from, next) => {
	if (store.state.tabbarKeepAlive.includes(to.name)) {
		store.commit('clearTempKeepAlive')
	} else {
		store.commit('handleTempKeepAlive', { toName: to.name, fromName: from.name })
	}
	next()
	if (to.meta['landscape'] !== from.meta['landscape']) {
		try {
			if (to.meta['landscape']) {
				screen.orientation.unlock()
				screen.orientation.lock('landscape')
			} else {
				screen.orientation.unlock()
				screen.orientation.lock('portrait')
			}
		} catch (e) {
			console.log(e)
		}
	}
})

export default router
export { viewRouters, demoRouters }
